// @flow
import moment from 'moment';
import _ from 'lodash';
import { websocketSettings } from 'common/config/config';
import type { Message, MessageRouter } from '../domain/Message';

type GetToken = () => string;

export class NotificationClient {
  websocket: ?WebSocket = null;
  lastHeartbeat: moment;
  heartbeatInterval: any;
  closed: boolean = true;

  getToken: GetToken;
  messageRouter: MessageRouter;

  constructor(getToken: GetToken, messageRouter: MessageRouter) {
    this.getToken = getToken;
    this.messageRouter = messageRouter;

    this.open = _.throttle(this.open, 1000);
  }

  send = (message: Message) => {
    this.websocket && this.websocket.send(JSON.stringify(message));
  }

  authenticate = (token: string) => {
    this.send({ type: 'AUTHENTICATE', accessToken: token });
  }

  open = () => {
    this.closed = false;
    if (this.isConnected()) {
      return;
    }

    const token = this.getToken();
    const url = `${websocketSettings.url}/notifications?token=${token}`;
    this.websocket = new WebSocket(url);

    this.websocket.onopen = this.onOpen;
    this.websocket.onmessage = this.onMessage;
    this.websocket.onclose = this.onClose;
    this.lastHeartbeat = moment();
  }

  close = () => {
    this.closed = true;
    this.websocket && this.websocket.close();
  }

  isConnected = () => {
    return this.websocket
      && [WebSocket.OPEN, WebSocket.CONNECTING].indexOf(this.websocket.readyState) !== -1;
  }

  onMessage = (event: MessageEvent) => {
    const eventData = (event.data: any);
    const data = JSON.parse(eventData);

    if (!data.type) {
      return;
    }

    if (data.type === 'HEARTBEAT') {
      this.lastHeartbeat = moment();
    }

    this.messageRouter.route(data.type, data);
  }

  onOpen = () => {
    this.heartbeatInterval = setInterval(this.checkHealth, 500);
  }

  onClose = () => {
    clearInterval(this.heartbeatInterval);

    if (this.closed) {
      return;
    }

    this.websocket = null;
    this.open();
  }

  checkHealth = () => {
    if (!this.isConnected()) {
      return;
    }

    const timeSinceLastHeartbeat = moment.duration(moment().diff(this.lastHeartbeat));
    if (timeSinceLastHeartbeat.asSeconds() < 60) {
      return;
    }

    this.websocket && this.websocket.close();
  }
}

let client: ?NotificationClient = null;
export default {
  open(getToken: GetToken, messageRouter: MessageRouter) {
    if (client && client.isConnected()) {
      return client;
    }

    client = new NotificationClient(getToken, messageRouter);
    client.open();

    return client;
  },

  send(message: Message) {
    if (!client) {
      return;
    }

    client.send(message);
  },

  close() {
    if (!client) {
      return;
    }

    client.close();
  },
};



// WEBPACK FOOTER //
// ./src/common/modules/notifications/services/NotificationClient.js